import React, {useRef, useState} from "react";
import "./_club-finder-single-result.scss";
import ClubHeader from "../../../atoms/club-header/club-header";
import ClubTile from "../../atoms/club-tile/club-tile";
import ClubContactDetails from "../../../atoms/club-contact-details/club-contact-details";
import ClubDescription from "../../../atoms/club-description/club-description";
import ClubCompetitionTileVersion2 from "../../atoms/club-competition-tile/club-competition-tile";
import {
  ClubDetailsTypes
} from "../../../../types/ApiTypeDefinition/singleClubFinderResultTypes";
import AccordionItem from "../../atoms/accordion-item/accordion-item";
import UserIcon from "../../../assets/icons/users.svg";
import ContactIcon from "../../../assets/icons/contact.svg"

const baseClass = 'club-finder-single-result';

interface ClubFinderSingleResultPropType {
  clubFinderSingleResult: ClubDetailsTypes
  buttonActionHandle: any
  backButtonEnabled: boolean
  tenant?: string
}

const ClubFinderSingleResult = (props: ClubFinderSingleResultPropType): JSX.Element => {
  const clubRegistrationForms = props.clubFinderSingleResult ? props.clubFinderSingleResult.registrationForms : null
  const clubProgramList = (clubRegistrationForms && clubRegistrationForms.programRegistrationForms) ? clubRegistrationForms.programRegistrationForms.map((clubCompetition: any, index: number) =>
    <ClubCompetitionTileVersion2 competitionDetails={clubCompetition} clubLogoVisible={true} key={index}
                                 extraFeesApplicableMessage={props.clubFinderSingleResult.extraFeesApplicableMessage}
                                 state={props.clubFinderSingleResult.address && props.clubFinderSingleResult.address.state ? props.clubFinderSingleResult.address.state : ''}
                                 extraFeesApplicable={props.clubFinderSingleResult.extraFeesApplicable}
    />
  ) : null;

  const clubCompetitionList = (clubRegistrationForms && clubRegistrationForms.competitionRegistrationForms) ? clubRegistrationForms.competitionRegistrationForms.map((clubCompetition: any, index: number) =>
    <ClubCompetitionTileVersion2 competitionDetails={clubCompetition} clubLogoVisible={true} key={index}
                                 extraFeesApplicableMessage={props.clubFinderSingleResult.extraFeesApplicableMessage}
                                 state={props.clubFinderSingleResult.address && props.clubFinderSingleResult.address.state ? props.clubFinderSingleResult.address.state : ''}
                                 extraFeesApplicable={props.clubFinderSingleResult.extraFeesApplicable}/>
  ) : null;

  const overflowContentRef = useRef<HTMLDivElement>(null);
  const [scrollHeight, setScrollHeight] = useState(0);
  const onScroll = () => {
    if(overflowContentRef && overflowContentRef.current) {
      const scrollTop = overflowContentRef.current.scrollTop
      setScrollHeight(scrollTop);
    }
  }

  return (
    <div className={`${baseClass}--version-2`}>
      <ClubHeader buttonActionHandle={props.buttonActionHandle} backButtonEnabled={props.backButtonEnabled}
                  clubLogo={props.clubFinderSingleResult.orgLogo && props.clubFinderSingleResult.orgLogo ? props.clubFinderSingleResult.orgLogo : ''}
                  tenant={props.tenant}/>
      <ClubTile clubDetails={props.clubFinderSingleResult} clubLogoVisible={false}  tenant={props.tenant}
                clubTileContainerStyles={`${baseClass}--tile-container-style`} index={0}
                contentScrolledHeight={scrollHeight}/>
      <div onScroll={onScroll} ref={overflowContentRef} className={`${baseClass}--club-details-list-overflow`}>
        <ClubContactDetails contactNumber={props.clubFinderSingleResult.contactNumber}
                            mailId={props.clubFinderSingleResult.contactEmail}
                            websiteText={props.clubFinderSingleResult.contactWebsite} tenant={props.tenant}/>
        {props.clubFinderSingleResult.contacts && props.clubFinderSingleResult.contacts.length > 0 && (
          <AccordionItem accordionTitle={'Organisation Contact Information'}
                         organisationContactItems={props.clubFinderSingleResult.contacts}
                         iconBeforeText={ContactIcon}/>
        )}

        {((props.clubFinderSingleResult.formats && props.clubFinderSingleResult.formats.length > 0) || (props.clubFinderSingleResult.description && props.clubFinderSingleResult.description.length > 0)) && (
          <ClubDescription clubFormatObject={props.clubFinderSingleResult.formats}
                           clubDescription={props.clubFinderSingleResult.description}
                           inclusions={props.clubFinderSingleResult.inclusions}/>
        )}

        {props.clubFinderSingleResult.demographics && props.clubFinderSingleResult.demographics.length > 0 && (
          <AccordionItem accordionTitle={'Age & Gender Information'}
                         demographicsList={props.clubFinderSingleResult.demographics} iconBeforeText={UserIcon}/>
        )}

        {clubRegistrationForms && (clubRegistrationForms.programRegistrationForms && clubRegistrationForms.programRegistrationForms.length > 0) && (
          <div className={`${baseClass}--registration-form-heading`}>
            Programs we offer
          </div>
        )}
        {clubProgramList}
        {clubRegistrationForms && (clubRegistrationForms.competitionRegistrationForms && clubRegistrationForms.competitionRegistrationForms.length > 0) && (
          <div className={`${baseClass}--registration-form-heading`}>
            Competitions we offer
          </div>
        )}
        {clubCompetitionList}
      </div>
    </div>
  )
}

export default ClubFinderSingleResult;
